import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { MeetingProvider } from './useDeleteMeeting';
import { invalidateActivitiesQueries } from '../event/useActivitiesSearch';
import { invalidateTimelineQueries } from '../timeline/useSearchTimeline';

export interface PatchMeetingPayload {
  meetingId: number;
  provider: MeetingProvider;
  startTime?: string;
  endTime?: string | null;
  isAllDay?: boolean;
}

const patchMeeting = (payload: PatchMeetingPayload) => {
  const request: Request = {
    url: ENDPOINTS.calendar.meeting,
    config: {
      method: 'PATCH',
      data: {
        data: payload,
      },
    },
  };
  return client(request);
};

export default function usePatchMeeting() {
  const queryClient = useQueryClient();
  return useMutation<Response<null>, CronoError, PatchMeetingPayload>(
    patchMeeting,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.events.event]);
        invalidateActivitiesQueries(queryClient);
        invalidateTimelineQueries(queryClient);
      },
    },
  );
}
